import routes from "../../common/api-routes";
import {HttpAuthGet, HttpAuthPost, HttpAuthPut} from "../../../../../core/services/common/HttpRequestBuilder"


const listOrg = (parameters) => {

    let result = HttpAuthGet(routes.LIST_ORG, parameters);
    return result;
}

const createOrg = (payload) => {
    let result = HttpAuthPost(routes.CREATE_ORG, payload);
    return result;
}

const viewOrg = (org_uid) => {

    let query_params ={
        org_uid: org_uid
    }
    let result = HttpAuthGet(routes.VIEW_ORG, query_params);

    return result
}

const listOrgUsers = (org_uid, page, searchFor, searchVal, limit) => {
    let query_params = {
        org_uid: org_uid,
        page: page,
        searchFor: searchFor,
        searchVal: searchVal,
        limit: limit,

    }

    let result = HttpAuthGet(routes.LIST_ORGANIZATION_USER, query_params);

    return result
}

const updateOrg = (payload) => {
    let result = HttpAuthPut(routes.UPDATE_ORG, payload);
    return result;
}

const listVehicleOrg = (parameters) => {

    let result = HttpAuthGet(routes.LIST_ORG_VEHICLE, parameters);

    return result
}

const listOrgGatepass = (parameters) => {
    let result = HttpAuthGet(routes.LIST_ORG_GATEPASS, parameters);
    return result
}

const viewOrgSubscription = (parameters) => {
    let result = HttpAuthGet(routes.VIEW_ORG_SUBSCRIPTION, parameters)
    return result
}

const filterListOrg = (parameters) => {
    let result = HttpAuthGet(routes.FILTER_LIST_ORG, parameters)
    return result
}

const OrganizationService = {
    listOrg,
    createOrg,
    viewOrg,
    listOrgUsers,
    updateOrg,
    listVehicleOrg,
    listOrgGatepass,
    viewOrgSubscription,
    filterListOrg
}

export default OrganizationService
